import PropTypes from 'prop-types';
import { BookOpen, Funnel, MagnifyingGlass } from '@phosphor-icons/react';
import { XGButton } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import './LibraryEmptyState.css';

const LibraryEmptyState = ({
  query = '',
  filterLabel = '',
  hasActiveFilters = false,
  noTypesSelected = false,
  onClear,
  onClearFilters,
  onSelectAllTypes,
  compact = false
}) => {
  const { t } = useTranslation('library');
  const hasQuery = Boolean(query.trim());
  const hasFilter = hasActiveFilters || Boolean(filterLabel);
  const Icon = noTypesSelected
    ? Funnel
    : hasQuery || hasFilter
      ? MagnifyingGlass
      : BookOpen;

  return (
    <div
      className={`library-empty-state${compact ? ' library-empty-state--compact' : ''}`}
      data-testid={
        noTypesSelected
          ? 'library-no-types-selected'
          : hasQuery || hasFilter
            ? 'library-no-results'
            : 'library-empty'
      }
    >
      <Icon size={56} color='#98a2b3' weight='regular' aria-hidden='true' />
      <h2 className='library-empty-state__title'>
        {noTypesSelected
          ? t('noTypesSelectedTitle', { defaultValue: 'No types selected' })
          : hasQuery
            ? t('noResultsTitle', { query: query.trim() })
            : filterLabel
              ? t('noResultsForTypeTitle', { type: filterLabel })
              : hasFilter
                ? t('noFilteredResultsTitle')
                : t('emptyLibraryTitle')}
      </h2>
      <p className='library-empty-state__description'>
        {noTypesSelected
          ? t('noTypesSelectedDescription', {
              defaultValue:
                'Choose at least one type in the filter to see results.'
            })
          : hasQuery
            ? t('noResultsDescription')
            : hasFilter
              ? t('noFilteredResultsDescription')
              : t('emptyLibraryDescription')}
      </p>
      {noTypesSelected && onSelectAllTypes && (
        <XGButton
          id='library-select-all-types'
          className='library-empty-state__action'
          text={t('selectAllTypes', { defaultValue: 'Select all types' })}
          type='primary'
          size='medium'
          variant='contained'
          onClick={onSelectAllTypes}
        />
      )}
      {!noTypesSelected && hasQuery && onClear && (
        <XGButton
          id='library-clear-search'
          className='library-empty-state__action'
          text={t('clearSearch')}
          type='primary'
          size='medium'
          variant='contained'
          onClick={onClear}
        />
      )}
      {!noTypesSelected && !hasQuery && hasFilter && onClearFilters && (
        <XGButton
          id='library-clear-filters'
          className='library-empty-state__action'
          text={t('clearFilters')}
          type='primary'
          size='medium'
          variant='contained'
          onClick={onClearFilters}
        />
      )}
    </div>
  );
};

LibraryEmptyState.propTypes = {
  query: PropTypes.string,
  filterLabel: PropTypes.string,
  hasActiveFilters: PropTypes.bool,
  noTypesSelected: PropTypes.bool,
  onClear: PropTypes.func,
  onClearFilters: PropTypes.func,
  onSelectAllTypes: PropTypes.func,
  compact: PropTypes.bool
};

export default LibraryEmptyState;
